import React from 'react';
import { useApp } from '../AppContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang } = useApp();

  return (
    <div
      role="group"
      aria-label="Language selector"
      className={`inline-flex items-center rounded-full border-[1.5px] border-black overflow-hidden text-sm font-bold ${className}`}
    >
      <button
        type="button"
        onClick={() => setLang('it')}
        className={`px-4 h-11 min-w-[48px] flex items-center justify-center transition ${lang === 'it' ? 'bg-black text-white' : 'bg-white text-black hover:bg-black/5 active:bg-black/10'}`}
        aria-pressed={lang === 'it'}
        aria-label="Italiano"
      >IT</button>
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`px-4 h-11 min-w-[48px] flex items-center justify-center transition ${lang === 'en' ? 'bg-black text-white' : 'bg-white text-black hover:bg-black/5 active:bg-black/10'}`}
        aria-pressed={lang === 'en'}
        aria-label="English"
      >EN</button>
    </div>
  );
};

export default LanguageSwitcher;
